// Builds Formik initialValues for preset-answer selection.
// - Empty response: array of n empty slots (one per preset).
// - Single-select with response: [firstResponseNanoid].
// - Multi-select with response: preset.map(nanoid if selected else "").
export function buildPresetInitialValues(presets, response, answerType) {
    if (response.length === 0) {
        return new Array(presets.length);
    }
    if (answerType === "single") {
        return [response[0].nanoid];
    }
    return presets.map((p) =>
        response.some((ele) => ele.nanoid === p.nanoid) ? p.nanoid : "",
    );
}
